var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-telegram-plane","data-name":"Icon awesome-telegram-plane","d":"M35.412,7.239,30.053,32.513c-.4,1.784-1.459,2.228-2.957,1.387l-8.165-6.017-3.94,3.789a2.051,2.051,0,0,1-1.641.8l.587-8.316L29.07,10.482c.658-.587-.143-.912-1.023-.325L9.339,21.937,1.284,19.416c-1.752-.547-1.784-1.752.365-2.592l31.5-12.137C34.612,4.14,35.888,5.012,35.412,7.239Z","transform":"translate(-0.001 -4.528)","fill":"#fff"}));
}

Telegram.defaultProps = {"id":"telegram_icon","data-name":"telegram icon","width":"35.513","height":"29.782","viewBox":"0 0 35.513 29.782"};

module.exports = Telegram;

Telegram.default = Telegram;
